import { useAdminVoucherPage } from "../../../Hooks/useAdminVoucher";
import Styles from "./index.module.scss";
import clsx from "clsx";
import PaginationComponent from "../../../Share/Component/Pagination";
import TableComponent from "../../../Share/Component/Table";
import {
  VOUCHER_TABLE_COLUMNS,
  VOUCHER_DELETED_TYPES,
  VOUCHER_DELETED_COLUMNS,
} from "../../../Constants/voucher";
import { formatDate } from "../../../Utils/index";
import AdminModal from "../../../Components/Atoms/Modal";
import { CreateVoucherForm } from "../../../Components/Molecules/CreateVoucherForm";
import Select from "react-select";

function AdminVoucher() {
  const {
    search,
    vouchers,
    paging,
    control,
    showCreateModal,
    type,
    handleCloseCreateModal,
    handleShowCreateModal,
    handleSubmit,
    setSearch,
    getVouchers,
    handleSetYear,
    handleSetMonth,
    handleSelectType,
    formatMinPay,
    formatMonthYear,
    handleDelete,
    handleShowUpdateModal,
    formatRate,
  } = useAdminVoucherPage();

  return (
    <>
      <div className={clsx(Styles.main, "flex-grow-1")}>
        <div className={clsx(Styles.bodyMain, "container-fluid my-1")}>
          <div className={clsx(Styles.bodyMainTop)}>
            <div className={clsx(Styles.filterWrap)}>
              <div className={clsx(Styles.searchWrap)}>
                <input
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className={clsx(Styles.search)}
                />
                <span
                  onClick={() => getVouchers(0)}
                  className={clsx(Styles.contentSearch)}
                >
                  Search
                </span>
              </div>
              <div className={clsx(Styles.filterBody)}>
                <div className={clsx(Styles.typeWrap)}>
                  <Select
                    value={type}
                    onChange={handleSelectType}
                    options={VOUCHER_DELETED_TYPES}
                  />
                </div>
                <div
                  onClick={handleShowCreateModal}
                  className={clsx(Styles.btnCreate)}
                >
                  <span className={clsx(Styles.label)}>Tạo mã khuyến mãi</span>
                </div>
              </div>
            </div>
          </div>
          <div className={clsx(Styles.table)} id="style-3">
            <TableComponent
              data={vouchers}
              header={
                type.value ? VOUCHER_DELETED_COLUMNS : VOUCHER_TABLE_COLUMNS
              }
              customFormatters={{
                created_at: formatDate,
                limit1: formatMinPay,
                limit2: formatMinPay,
                min_pay: formatMinPay,
                month: formatMonthYear,
                deleted_at: formatDate,
                ref_rate: formatRate,
              }}
              isShowDelete={!type.value}
              handleDelete={handleDelete}
              onRowClick={handleShowUpdateModal}
            />
          </div>
          <div className={clsx(Styles.footer)}>
            <div className={clsx(Styles.footerWrap)}>
              <PaginationComponent page={paging} handleCallApi={getVouchers} />
            </div>
          </div>
        </div>
      </div>
      {showCreateModal && (
        <AdminModal
          title="Thêm mã khuyến mãi"
          isShow={showCreateModal}
          handleCloseModal={handleCloseCreateModal}
        >
          <CreateVoucherForm
            handleSetMonth={handleSetMonth}
            handleSetYear={handleSetYear}
            handleSubmit={handleSubmit}
            control={control}
          />
        </AdminModal>
      )}
    </>
  );
}

export default AdminVoucher;
